import Vue from 'vue';
import App from './App.vue';
import VueRouter from 'vue-router';
import VueI18n from 'vue-i18n';
import VueIziToast from 'vue-izitoast';
import 'izitoast/dist/css/iziToast.css';
import { routes } from './router';
import { messages } from './lang/locales';
import { TokenService } from "./utils/storageService";
import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
// import 'videojs-flash'
import 'videojs-contrib-hls/dist/videojs-contrib-hls'

export const EventBus = new Vue({
    data() {
        return {
            routeImages: './src/assets/images/'
        }
    }
});

Vue.config.productionTip = false;
Vue.use(VueI18n);
Vue.use(VueRouter);
Vue.use(VueIziToast);
Vue.use(VueVideoPlayer)

const router = new VueRouter({
    routes: routes,
    mode: 'history',
    base: process.env.BASE_URL
});
router.beforeEach((to, from, next) => {
    // console.log(`[FN] GLOBAL beforeEach: ${from.name} to ${to.name}`);
    let sess = TokenService.getSession();
    // console.log('>> Sess:', sess);
    let auth = to.matched.some(record => record.meta.auth);

    if (auth && !sess) {
        next('/')
    } else if (to.name === 'findme') {
        next()
    } else {
        next()
    }
});

const i18n = new VueI18n({
    locale: 'en',
    messages
});

new Vue({
    el: '#app',
    router,
    i18n,
    render: h => h(App)
});